import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { useQuery } from "@tanstack/react-query";

import { getBeefFeedAdditives, getBeefFeedAdditivesAdmin } from "services";

import { getEnvironment, injectNames } from "utils";

import { DEFAULT_CACHE, GET_BEEF_FEED_ADDITIVES } from "consts";

import { BeefFeedAdditive } from "models";

export const useGetBeefFeedAdditives = () => {
  const { t } = useTranslation("beef", { useSuspense: false });
  const isAdmin = getEnvironment().admin;

  // Translate in select, not queryFn, so the cached data stays language-neutral and names follow language and namespace loads.
  const withTranslatedNames = useCallback((feedAdditives: BeefFeedAdditive[]) => injectNames(feedAdditives, t, "feedAdditives"), [t]);

  return useQuery({
    queryKey: [GET_BEEF_FEED_ADDITIVES, isAdmin],
    queryFn: () => (isAdmin ? getBeefFeedAdditivesAdmin() : getBeefFeedAdditives()),
    select: withTranslatedNames,
    gcTime: DEFAULT_CACHE.gcTime,
    staleTime: DEFAULT_CACHE.staleTime,
  });
};
